module.exports = __webpack_public_path__ + "img/five.bd032913.png";